(() => {
  const MOBILE = '(max-width: 749px)';
  const BG = 'https://cdn.shopify.com/s/files/1/0775/9000/3864/files/acbb0693221c19662bf3069624a45092.png';

  const important = (el, prop, value) => {
    if (el) el.style.setProperty(prop, value, 'important');
  };

  const textOf = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim();

  const commonAncestor = (first, second, boundary) => {
    if (!first || !second) return null;
    let node = first;
    while (node && node !== boundary?.parentElement) {
      if (node.contains(second)) return node;
      node = node.parentElement;
    }
    return null;
  };

  const styleBlock = (block, maxWidth = '300px') => {
    if (!block) return;
    important(block, 'position', 'relative');
    important(block, 'left', 'auto');
    important(block, 'right', 'auto');
    important(block, 'transform', 'none');
    important(block, 'z-index', '2');
    important(block, 'width', '100%');
    important(block, 'max-width', maxWidth);
    important(block, 'margin-left', 'auto');
    important(block, 'margin-right', 'auto');
    important(block, 'padding', '0');
    important(block, 'display', 'flex');
    important(block, 'justify-content', 'center');
    important(block, 'align-items', 'center');
    important(block, 'text-align', 'center');

    block.querySelectorAll('*').forEach((el) => {
      important(el, 'text-align', 'center');
      important(el, 'margin-left', 'auto');
      important(el, 'margin-right', 'auto');
    });
  };

  const applyOtrasMarcas = () => {
    if (!window.matchMedia(MOBILE).matches) return;

    const main = document.querySelector('#MainContent[data-template^="index"]');
    if (!main) return;

    const heading = [...main.querySelectorAll('h1,h2,h3,h4,h5,h6,p')]
      .find((el) => /^(Más|Otras)\s+Marcas$/i.test(textOf(el)));
    if (!heading) return;

    const section = heading.closest('.shopify-section') || heading.closest('section') || heading.parentElement;
    if (!section) return;

    const paragraph = [...section.querySelectorAll('p')]
      .find((el) => el !== heading && /Compartimos el mismo amor|Explorá las demás marcas|Explora las demás marcas/i.test(textOf(el)));
    const button = [...section.querySelectorAll('a,button')]
      .find((el) => /Ir a Otras Marcas|Explorar ya!/i.test(textOf(el)));

    const panel = heading.closest('.group-block')
      || commonAncestor(heading, button || paragraph, section)
      || section.querySelector('.group-block')
      || section;

    const headingBlock = heading.closest('[id*="__text_"]') || heading.parentElement;
    const paragraphBlock = paragraph?.closest('[id*="__text_"]') || paragraph?.parentElement;
    const buttonBlock = button?.closest('[id*="__button_"]') || button?.parentElement;

    important(section, 'overflow', 'visible');
    important(section, 'text-align', 'center');

    important(panel, 'position', 'relative');
    important(panel, 'isolation', 'isolate');
    important(panel, 'box-sizing', 'border-box');
    important(panel, 'display', 'flex');
    important(panel, 'flex-direction', 'column');
    important(panel, 'align-items', 'center');
    important(panel, 'justify-content', 'center');
    important(panel, 'gap', '18px');
    important(panel, 'width', '100%');
    important(panel, 'max-width', 'none');
    important(panel, 'min-height', '430px');
    important(panel, 'margin', '0 auto');
    important(panel, 'padding', '46px 30px 42px');
    important(panel, 'overflow', 'hidden');
    important(panel, 'text-align', 'center');
    important(panel, 'background-color', '#2f111c');
    important(panel, 'background-image', `linear-gradient(to bottom, rgba(28,8,15,.25) 0%, rgba(28,8,15,.46) 52%, rgba(28,8,15,.68) 100%), url("${BG}")`);
    important(panel, 'background-size', 'cover');
    important(panel, 'background-position', 'center center');
    important(panel, 'background-repeat', 'no-repeat');

    styleBlock(headingBlock, '290px');
    styleBlock(paragraphBlock, '290px');
    styleBlock(buttonBlock, '100%');

    important(heading, 'margin', '0 auto');
    important(heading, 'max-width', '290px');
    important(heading, 'color', '#ffffff');
    important(heading, 'font-size', 'clamp(1.7rem, 7.8vw, 2rem)');
    important(heading, 'font-weight', '700');
    important(heading, 'line-height', '1.08');
    important(heading, 'letter-spacing', '-.02em');
    important(heading, 'text-align', 'center');
    important(heading, 'text-shadow', '0 2px 12px rgba(0,0,0,.62)');

    if (paragraph) {
      important(paragraph, 'margin', '0 auto');
      important(paragraph, 'max-width', '285px');
      important(paragraph, 'color', '#ffffff');
      important(paragraph, 'font-size', '.94rem');
      important(paragraph, 'line-height', '1.48');
      important(paragraph, 'font-weight', '500');
      important(paragraph, 'text-align', 'center');
      important(paragraph, 'text-shadow', '0 2px 10px rgba(0,0,0,.62)');
    }

    if (button) {
      important(buttonBlock, 'margin-top', '4px');
      important(buttonBlock, 'display', 'flex');
      important(buttonBlock, 'justify-content', 'center');
      important(buttonBlock, 'align-items', 'center');

      important(button, 'position', 'relative');
      important(button, 'left', 'auto');
      important(button, 'right', 'auto');
      important(button, 'top', 'auto');
      important(button, 'bottom', 'auto');
      important(button, 'transform', 'none');
      important(button, 'display', 'inline-flex');
      important(button, 'align-items', 'center');
      important(button, 'justify-content', 'center');
      important(button, 'width', 'auto');
      important(button, 'min-height', '48px');
      important(button, 'margin', '0 auto');
      important(button, 'padding', '12px 24px');
      important(button, 'border', '1px solid rgba(255,255,255,.98)');
      important(button, 'border-radius', '14px');
      important(button, 'background', 'rgba(255,255,255,.97)');
      important(button, 'color', '#51192a');
      important(button, 'box-shadow', '0 8px 24px rgba(28,7,14,.34)');
      important(button, 'font-weight', '600');
      important(button, 'line-height', '1');
      important(button, 'white-space', 'nowrap');
      important(button, 'text-align', 'center');
      important(button, 'text-decoration', 'none');
    }
  };

  const applyCollaborations = () => {
    if (!window.matchMedia(MOBILE).matches) return;

    const footer = document.querySelector('footer');
    if (!footer) return;

    const heading = [...footer.querySelectorAll('h1,h2,h3,h4,h5,h6,p')]
      .find((el) => /^Colaboraciones\s*&\s*Canjes$/i.test(textOf(el)));
    if (!heading) return;

    const section = heading.closest('.shopify-section') || heading.closest('section') || heading.parentElement;
    const paragraph = [...section.querySelectorAll('p')]
      .find((el) => /influencer|creador\/a de contenido|campañas o canjes/i.test(textOf(el)));

    const panel = heading.closest('.group-block')
      || commonAncestor(heading, paragraph, section)
      || section.querySelector('.group-block')
      || section;
    const headingBlock = heading.closest('[id*="__text_"]') || heading.parentElement;
    const paragraphBlock = paragraph?.closest('[id*="__text_"]') || paragraph?.parentElement;

    important(section, 'overflow', 'visible');
    important(section, 'text-align', 'center');
    important(panel, 'display', 'flex');
    important(panel, 'flex-direction', 'column');
    important(panel, 'align-items', 'center');
    important(panel, 'justify-content', 'center');
    important(panel, 'gap', '10px');
    important(panel, 'box-sizing', 'border-box');
    important(panel, 'width', '100%');
    important(panel, 'max-width', 'none');
    important(panel, 'margin', '0 auto');
    important(panel, 'padding', '24px 52px 92px');
    important(panel, 'text-align', 'center');

    styleBlock(headingBlock, '255px');
    styleBlock(paragraphBlock, '240px');
    important(heading, 'margin', '0 auto');
    important(heading, 'max-width', '255px');
    important(heading, 'color', '#ffffff');
    important(heading, 'font-size', 'clamp(1.62rem, 7.5vw, 1.95rem)');
    important(heading, 'font-weight', '700');
    important(heading, 'line-height', '1.08');
    important(heading, 'text-align', 'center');

    if (paragraph) {
      important(paragraph, 'margin', '0 auto');
      important(paragraph, 'max-width', '240px');
      important(paragraph, 'color', '#ffffff');
      important(paragraph, 'font-size', '.88rem');
      important(paragraph, 'line-height', '1.45');
      important(paragraph, 'text-align', 'center');
    }
  };

  const applyAll = () => {
    applyOtrasMarcas();
    applyCollaborations();
  };

  const start = () => {
    applyAll();
    [100, 300, 700, 1400, 2200].forEach((ms) => setTimeout(applyAll, ms));
    new MutationObserver(() => requestAnimationFrame(applyAll))
      .observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', applyAll);
    document.addEventListener('shopify:section:select', applyAll);
    window.addEventListener('resize', applyAll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
